// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qjgfpmpruszbgvggqdmg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFqZ2ZwbXBydXN6Ymd2Z2dxZG1nIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUwMTU0MjUsImV4cCI6MjA2MDU5MTQyNX0.Prma6f_7XAKMOVnHFNXks_Y7L5rFQU3Q6IFuBG0hMbM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);